import AppState from "@/plugins/appstate"
import { store, session } from "@/api/store"
import {
  auth,
  user,
  SetHeader,
  applyLicenseGate,
  setPermission,
  ssoAccessAPI,
  loginComplete,
  envCheckInsert,
  beforeCheckLogin,
  mobileBeforeCheckLogin,
  getNetworkType,
  logout,
} from "@/api/access"
import router from "@/router"
import moment from "moment"
import { getCompanyFunction } from "../api/util"

const checkAuth = async to => {
  // store 초기화 완료 대기 (IndexedDB → 메모리 캐시 로드)
  await store.waitForInitialization()

  if (auth()) {
    const data = await getCompanyFunction("manager_idle_timeout")
    const networkType = getNetworkType()
    const userInfo = user()
    // if (networkType.indexOf("internal") === 0 && userInfo.type === "Member") {
    //   router.replace({ name: "error", params: { code: "direct" } })
    //   setTimeout(async () => {
    //     await logout()
    //   }, 500)
    // }
    if (to && to.meta.auth) {
      if (!to.meta.auth.includes(userInfo.type)) {
        router.replace({ name: "error", params: { code: "direct" } })
      }
    }

    if (store.get("expireTime") || store.get("forceExpireTime")) {
      if (moment.duration(moment(store.get("expireTime")).diff(moment())).asSeconds() < 0) {
        router.replace({ name: "error", params: { code: "session" } })
        store.remove("expireTime")
        setTimeout(async () => {
          await logout()
        }, 500)
      } else if (moment.duration(moment(store.get("forceExpireTime")).diff(moment())).asSeconds() < 0) {
        router.replace({ name: "error", params: { code: "session" } })
        store.remove("expireTime")
        setTimeout(async () => {
          await logout()
        }, 500)
      }
      // 유휴 세선 로그아웃 4시간 설정
      else {
        store.set(
          "expireTime",
          moment()
            // .add(60, "minutes")
            .add(data, "minutes")
            .toDate(),
        )
      }
    } else {
      store.set(
        "expireTime",
        moment()
          // .add(60, "minutes")
          .add(data, "minutes")
          .toDate(),
      )
    }
    return true
  } else {
    const stored = store.get("user")
    const token = session.get("token")

    if (!token) return false
    if (stored) {
      SetHeader("token", stored.token)
      auth(true)
      user(stored)
      if (!AppState.Info.dateFmt) {
        AppState.Info.dateFmt = stored.dateFmt
      }
      // 게이트를 백엔드 license 기반으로 세팅 (없으면 저장된 license.total로 폴백). getUserData와 동일.
      const backendLicense = (store.get("auth") || {}).license
      if (backendLicense && backendLicense.license_type) {
        applyLicenseGate(backendLicense.license_type)
      } else if (stored.license && stored.license.total) {
        applyLicenseGate(stored.license.total.primaryProdType)
      }
      setPermission(stored)
      return true
    } else {
      if (store.get("auth") !== undefined) {
        // user 정보 없이 auth만 있는 경우 (강제 로그인 직후 등)
        // session에서 가져온 token으로 헤더 설정
        SetHeader("token", token)
        return true
      }
      return false
    }
  }
}

const alreadyAuth = async (to, from, next) => {
  const lang = store.get("lang") || "ko"
  if (await checkAuth(to)) {
    next({ name: "device-root", params: { lang } })
  } else {
    next()
  }
}

const commonGuard = (to, from, next) => {
  return checkAuth(to) ? next() : next("/")
}

const licenseGuard = (to, from, next) => {
  if (checkAuth(to)) {
    if (AppState.isCorporate) next()
    else next({ name: "error", params: { code: "404" } })
  } else {
    next("/")
  }
}

const adminGuard = (to, from, next) => {
  if (checkAuth(to)) {
    if (AppState.perm.isAdmin) next()
    else next({ name: "error", params: { code: "404" } })
  } else {
    next("/")
  }
}

// MDM 게이트: Mdm 라이선스(isMdm) 회사만 /mdm 진입 허용. 메뉴만 숨기면 URL 직접입력으로 뚫려 라우트 레벨에서도 차단
const mdmGuard = (to, from, next) => {
  if (checkAuth(to)) {
    if (AppState.isMdm) next()
    else next({ name: "error", params: { code: "404" } })
  } else {
    next("/")
  }
}

export { alreadyAuth, commonGuard, licenseGuard, adminGuard, mdmGuard }
